<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row class="flex-nowrap">
            <rkm-col class="flex-grow-1">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :searchFields="localForm.autocompleteFields.usuario"
                    :validations="validations.usuario"
                    label="Supervisor"
                    text-field="cidadaoNome"
                    uppercase
                    v-model="supervisor.usuario"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {

                usuario: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data: () => ({
        localForm: {
            autocompleteFields: {
                usuario: [
                    { key: 'cadastroCidadao.nome', searchable: true },
                ],
            },
        },
        supervisor: {
            id: null,
            nome: null,
            usuarioId: null,
            cpf:  null
        },
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                 .then(valid => {

                    if (!valid) return

                        const supervisor = this.clone(this.supervisor)

                            if (this.hasOcupacaoParametrizada(supervisor.usuario.id)) {

                                this.resetForm()

                                this.showValidationNotification("Já existe um registro com esse supervisor.")
                                return
                            }

                        this.supervisor.id = this.uniqueId('supervisor' + new Date().getTime())

                        const param = {
                            id: this.supervisor.id,
                            nome: supervisor.usuario.cidadaoNome,
                            usuarioId: supervisor.usuario.id,
                            cpf: supervisor.usuario.cpf,
                        }

                        if (this.hasIndex) {

                            this.$set(this.data.model.supervisores, this.index, this.clone(param))
                        }
                        else {

                            this.data.model.supervisores.push(this.clone(param))
                        }

                        this.$emit('save', this.clone(param))
                })
        },
        hasOcupacaoParametrizada(usuario) {

            return this.data.model.supervisores.find(supervisor => supervisor.usuarioId === usuario)
        },
        resetForm() {

            this.supervisor.usuario = null
            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
    },
    mixins: [repository, object ],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
    },
}
</script>